import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "container-custom" }

import { reactive, ref } from "vue";
// LayoutHeader
import LayoutHeader from "@layouts/layout-header.vue";

const logined = false;

export default /*#__PURE__*/_defineComponent({
  __name: 'layout-without-sidebar',
  props: {
    isShowSideBar: {},
    isLogin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isShow = ref(true); // Задать значение по умолчанию
const isShowSideBar = ref(props.isShowSideBar ?? true); // Задать значение по умолчанию = props.isShow ?? true; // Задать значение по умолчанию
const isLogin = ref(props.isLogin ?? false); // Задать значение по умолчанию = props.isShow ?? true; // Задать значение по умолчанию
const MyDependency = {
	foo: "bar",
};
const settings = reactive({ theme: "light" });

return (_ctx: any,_cache: any) => {
  const _component_LayoutHeaderSimple = _resolveComponent("LayoutHeaderSimple")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LayoutHeaderSimple, {
      show: isShow.value,
      isLogin: isLogin.value
    }, null, 8, ["show", "isLogin"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["content", { hideBar: !isShowSideBar.value }]),
        style: {"padding":"0px"}
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(_component_router_view)
        ])
      ], 2)
    ])
  ]))
}
}

})